"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.YearMonthForm = void 0;
var moment = require("moment");
var React = require("react");
var theme_1 = require("../../utils/theme");
var ApDatePicker_styles_1 = require("./ApDatePicker.styles");
exports.YearMonthForm = function (_a) {
    var date = _a.date, localeUtils = _a.localeUtils, srcRange = _a.srcRange, onChange = _a.onChange;
    var _b = __read(React.useState(false), 2), isMenuOpen = _b[0], setIsMenuOpen = _b[1];
    var years = [];
    for (var i = srcRange.from.getFullYear(); i <= srcRange.to.getFullYear(); i += 1) {
        years.push(i);
    }
    var periodsStr = moment(date).startOf("month").format('MMMM') + " " + date.getFullYear();
    return (React.createElement(ApDatePicker_styles_1.MonthYearContainer, { className: "DayPicker-Caption" },
        React.createElement(ApDatePicker_styles_1.Wrapper, null,
            React.createElement(ApDatePicker_styles_1.PeriodButton, { onClick: function () { setIsMenuOpen(!isMenuOpen); } },
                periodsStr,
                React.createElement(ApDatePicker_styles_1.CaretIcon, { isRotate: isMenuOpen, iconName: "caret", iconColor: theme_1.colors.grey5 })),
            isMenuOpen && (React.createElement(ApDatePicker_styles_1.MenuContent, null,
                React.createElement(ApDatePicker_styles_1.PickerContent, null,
                    React.createElement(ApDatePicker_styles_1.PickerGrid, null, years.map(function (year) { return (React.createElement(ApDatePicker_styles_1.PickerPeriod, { key: year, onClick: function () {
                            onChange(new Date(Number(year), date.getMonth()));
                            setIsMenuOpen(false);
                        }, active: year === date.getFullYear() }, year)); }))))))));
};
//# sourceMappingURL=YearMonthForm.js.map